import { makeStyles, tokens } from '@fluentui/react-components';

export const useBulkAddDialogStyles = makeStyles({
    badgeCount: {
        marginTop: tokens.spacingHorizontalS,
    },
    previewContainer: {
        marginTop: tokens.spacingHorizontalS,
        display: 'flex',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalS,
    },
    previewItem: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalXS,
        paddingTop: tokens.spacingHorizontalXS,
        paddingBottom: tokens.spacingHorizontalXS,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalXS,
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: tokens.colorNeutralBackground3,
    },
    messageBar: {
        marginTop: tokens.spacingVerticalS,
    },
    processingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
    },
    footerContainer: {
        marginTop: tokens.spacingVerticalS,
    },
    resultsContainer: {
        marginTop: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    resultSection: {
        display: 'flex',
        flexDirection: 'column',
    },
    resultList: {
        marginLeft: '8px',
        marginTop: '4px',
        maxHeight: '150px',
        overflowY: 'auto',
    },
});